import { Button } from '@factorialco/deprecated-design-system'
import { type SelectOption } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import InlineTooltip from 'modules/core/components/InlineTooltip'
import Country from 'modules/core/components/Inputs/Country'
import Select from 'modules/core/components/Inputs/Select'
import Text from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'

import {
  FormTypes,
  useEmployeePersonalProvider,
} from 'modules/employees/components/blocks/EmployeePersonalProvider'
import type Employee from 'modules/employees/store/models/Employee'
import taxResidences from 'modules/payroll_bundle/store/collections/taxResidences'

import type { ScrollRowType } from '../types'

interface Props {
  form: Form
  employee: Employee
  isSpanish: boolean
  readonly: boolean
  scrollTo: ScrollRowType | null | undefined
}

const TaxResidenceForm = ({
  form,
  employee,
  isSpanish,
  readonly,

  scrollTo = null,
}: Props) => {
  const { onSubmit: onSubmitTaxResidence, disableSectionSaveButtons } =
    useEmployeePersonalProvider()
  const shouldScrollToRow = (type: ScrollRowType | null | undefined): boolean => {
    return scrollTo === type
  }
  const employeeTaxResidence = taxResidences.find({
    employee_id: employee.attributes.id,
  })

  const residentOptions: SelectOption[] = [
    {
      value: true,
      label: i18n.t('employee_form.tax_residence.resident'),
    },
    {
      value: false,
      label: i18n.t('employee_form.tax_residence.not_resident'),
    },
  ]

  const onSubmit = () => {
    onSubmitTaxResidence([FormTypes.TAX_RESIDENCE])
  }

  const isNotResident =
    form.get('is_resident').value === false || form.get('is_resident').value === 'false'

  return (
    <InlineTooltip>
      <FormComponent>
        <FormRow>
          <Select
            mandatory
            field={form.get('is_resident')}
            label={i18n.t('employee_form.is_resident')}
            none={i18n.t('common.choose')}
            options={residentOptions}
            readonly={readonly}
          />
        </FormRow>
        {isNotResident && (
          <FormRow multi scrollToRow={shouldScrollToRow('city_of_birth')}>
            <Text
              mandatory
              label={i18n.t('employee_form.tax_residence.city_of_birth')}
              field={form.get('city_of_birth')}
              readonly={readonly}
            />
            <Country
              mandatory
              label={i18n.t('employee_form.tax_residence.country_of_birth')}
              field={form.get('country_of_birth')}
              readonly={readonly}
            />
          </FormRow>
        )}
        {!disableSectionSaveButtons && (form.isDirty || (!employeeTaxResidence && isSpanish)) && (
          <FormRow footer>
            <Button onClick={onSubmit}>{i18n.t('common.submit')}</Button>
          </FormRow>
        )}
      </FormComponent>
    </InlineTooltip>
  )
}

export default observer(TaxResidenceForm)
